<template>
  <div class="container">
    <div class="word-processing">
      <h3>Convert Lines => List</h3>
      <b-row>
        <b-col cols="6">
          <b-textarea
            v-model="rawListWords"
              rows="10"
              class="word-input" />
        </b-col>
        <b-col cols="6">
  <div class="output-list">
  <pre>{{formattedListWords}}</pre>
  </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        rawListWords: '',
      }
    },
    computed: {
      formattedListWords() {
        let result = '';

        if (!this.rawListWords) {
          return '';
        }

        let lines = this.rawListWords.split('\n');

        result += '<ul>\n';
        for (const line of lines) {
          result += `\t\<li>${line}</li>\n`;
        }

        result += '</ul>';

        return result;
      }
    }
  }
</script>